import Request from "services";
import { Endpoints } from "services/endpoints";
import { handleRequestError } from "utils";
import { ChangePasswordRequestBody, Complete2FAResponseData, Enable2FAResponseData, GetProfileResponseBody, UpdateProfileRequest } from "./types";


export const getProfile = async () => {
    try {
        const response = await Request.getWithUserToken<GetProfileResponseBody>(Endpoints.profile);
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const updateProfile = async (data: UpdateProfileRequest) => {
    try {
        const response = await Request.putWithUserToken<GetProfileResponseBody>(Endpoints.profile, {data});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const changePassword = async (data: ChangePasswordRequestBody) => {
    try {
        const response = await Request.putWithUserToken<any>(Endpoints.changePassword, {data});
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}

export const enableMfa = async (password: string) => {
    try {
        const response = await Request.putWithUserToken<Enable2FAResponseData>(Endpoints.enableMfa, {data: {password}});
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};

export const disableMfa = async () => {
    try {
        const response = await Request.putWithUserToken<any>(Endpoints.disableMfa);
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};

export const completeMfa = async (token: string) => {
    try {
        const response = await Request.putWithUserToken<Complete2FAResponseData>(Endpoints.completeMfa(token));
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};

export const verifyMfaToken = async (token: string) => {
    try {
        const response = await Request.putWithUserToken<any>(Endpoints.verifyMfaToken(token));
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};
